import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Layout, Menu, Breadcrumb, Typography } from 'antd';
import './layout.css';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedMenu, setOpenKeys } from '../../redux';
import { CalendarIcon } from "@solar-icons/react/outline/calendar";
import { HamburgerMenuIcon } from "@solar-icons/react/outline/hamburger-menu";
import { Logout2Icon } from "@solar-icons/react/outline/logout-2";
import { ShieldCheckIcon } from "@solar-icons/react/outline/shield-check";
import moment from 'moment';
import { UserProfile } from './userProfile';
import { Scrollbars } from 'react-custom-scrollbars';
import { logout } from '../../redux/reducer/auth';
import CFG from '../../config/env';
const { Header, Content, Footer, Sider } = Layout;
const { Title, BaseColor } = CFG;
const { Text } = Typography;

const hexToRgba = (hex, alpha) => {
    const raw = (hex || '#158550').replace('#', '');
    const full = raw.length === 3 ? raw.split('').map(c => c + c).join('') : raw;
    const r = parseInt(full.slice(0, 2), 16), g = parseInt(full.slice(2, 4), 16), b = parseInt(full.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Cari jalur menu dari root sampai menu yang sedang aktif,
// supaya Breadcrumb header selalu mengikuti menu (Home / Master / Config ...).
const findMenuTrail = (items, selectedKey) => {
    const sel = `${selectedKey || ''}`.toLowerCase();
    const walk = (nodes, trail) => {
        for (const node of nodes || []) {
            const k = `${node?.key || ''}`.toLowerCase();
            if (!k) continue;
            if (sel === k || sel.indexOf(`${k}/`) === 0) {
                const next = [...trail, node];
                const deeper = walk(node.children, next);
                return deeper.length ? deeper : next;
            }
        }
        return trail;
    };
    return walk(items, []);
};

export const SiderLayout = ({ children, menus, title, theme, headerBgColor, headerColor }) => {
    const { selectedMenu, openKeys } = useSelector(state => state.nav);
    const { userdata } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const [colapsed, setColapsed] = useState(false);
    const [now, setNow] = useState(moment());
    const rootSubmenuKeys = useMemo(() => {
        return menus.map(({ key }) => key);
    }, [menus]);
    useEffect(() => {
        const timer = setInterval(() => setNow(moment()), 1000);
        return () => clearInterval(timer);
    }, []);
    const renderThumbVertical = useCallback(({ style }) => (
        <div
            className='app-scrollbar__thumb'
            style={{ ...style, borderRadius: 10, right: 2, width: 6, background: 'rgba(15, 23, 42, 0.18)', opacity: 0.85 }}
        />
    ), []);
    const renderTrackVertical = useCallback(({ style }) => (
        <div
            className='app-scrollbar__track'
            style={{ ...style, borderRadius: 12, right: 0, width: 10, bottom: 4, top: 4, background: 'transparent' }}
        />
    ), []);
    const renderView = useCallback(({ style }) => (
        <div
            style={{ ...style, paddingRight: 6 }}
            className='app-scrollbar__view'
        />
    ), []);
    const handleToggleCollapse = () => setColapsed(prev => !prev);
    const dateLabel = useMemo(() => now.clone().locale('en').format('dddd, DD MMM YYYY'), [now]);
    const effectiveTitle = title || Title;
    const baseColor = BaseColor || '#158550';
    const isDarkTheme = useMemo(() => (theme || 'light') === 'dark', [theme]);
    const effectiveHeaderBg = headerBgColor || (isDarkTheme ? '#0b1d33' : 'transparent');
    const effectiveHeaderColor = headerColor || (isDarkTheme ? '#f3f6fb' : '#141a17');
    const contentOffset = colapsed ? 92 : 288;
    const menuTrail = useMemo(() => findMenuTrail(menus, selectedMenu), [menus, selectedMenu]);
    const headerStyle = useMemo(() => ({
        backgroundColor: effectiveHeaderBg,
        color: effectiveHeaderColor,
        width: `calc(100% - ${contentOffset}px)`,
        zIndex: 99,
        position: 'fixed',
        top: 0,
        left: contentOffset,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        height: 80
    }), [contentOffset, effectiveHeaderBg, effectiveHeaderColor]);
    const headerClassName = useMemo(() => `site-layout-sub-header-background app-header ${isDarkTheme ? 'app-header--dark' : 'app-header--light'}`, [isDarkTheme]);
    const headerIcon = <HamburgerMenuIcon className='trigger' onClick={handleToggleCollapse} />;
    return (
        <Layout
            hasSider
            className='sider-layout'
            style={{ '--sider-brand': baseColor, '--sider-brand-soft': hexToRgba(baseColor, 0.12) }}
        >
            <Sider
                className={`app-sider ${colapsed ? 'app-sider--collapsed' : ''}`}
                style={{ height: '100vh', position: 'fixed', top: 0, bottom: 0, left: 0, background: '#ffffff' }}
                breakpoint="lg"
                theme={theme || 'light'}
                collapsed={colapsed}
                collapsedWidth={92}
                width={288}
            >
                <div className='app-sider__container'>
                    <div className='app-sider__brand'>
                        <div className='app-sider__logo'>
                            <img src={'/images/iacas.png'} alt="IACAS" />
                        </div>
                    </div>
                    <Scrollbars
                        renderThumbVertical={renderThumbVertical}
                        renderTrackVertical={renderTrackVertical}
                        renderView={renderView}
                        autoHide
                        autoHideTimeout={260}
                        autoHideDuration={200}
                        className='app-sider__scroll'
                    >
                        <Menu
                            mode="inline"
                            selectedKeys={[selectedMenu]}
                            theme={theme || 'light'}
                            items={menus || []}
                            onClick={e => {
                                dispatch(setSelectedMenu(e.key));
                            }}
                            openKeys={openKeys}
                            onOpenChange={keys => {
                                const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
                                if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                                    dispatch(setOpenKeys(keys));
                                } else {
                                    dispatch(setOpenKeys(latestOpenKey ? [latestOpenKey] : []));
                                }
                            }}
                        />
                    </Scrollbars>
                    <div className='app-sider__bottom'>
                        {!colapsed && (
                            <div className='app-sider__sync'>
                                <ShieldCheckIcon className='app-sider__sync-icon' />
                                <Text strong className='app-sider__sync-title'>Terhubung ke Bea Cukai</Text>
                                <Text className='app-sider__sync-desc'>Sinkronisasi data berjalan otomatis setiap ada pengiriman baru.</Text>
                            </div>
                        )}
                        <div className='app-sider__logout' onClick={() => dispatch(logout())}>
                            <Logout2Icon />
                            {!colapsed && <span>Logout</span>}
                        </div>
                    </div>
                </div>
            </Sider>
            <Layout style={{ marginLeft: contentOffset, minHeight: '100vh', background: '#f6f8f7' }}>
                <Header className={headerClassName} style={headerStyle}>
                    <div className='app-header__left'>
                        <span className='app-header__collapse'>{headerIcon}</span>
                        {menuTrail.length > 0 ? (
                            <Breadcrumb className='app-header__breadcrumb'>
                                {menuTrail.map((item) => (
                                    <Breadcrumb.Item key={item.key}>{item.label}</Breadcrumb.Item>
                                ))}
                            </Breadcrumb>
                        ) : (
                            <span className='app-header__title-fallback'>{effectiveTitle}</span>
                        )}
                    </div>
                    <div className='app-header__right'>
                        <span className='app-header__date'><CalendarIcon />{dateLabel}</span>
                        <UserProfile isColapsed={colapsed} username={userdata?.username} level={userdata?.levelStr} />
                    </div>
                </Header>
                <Content style={{ margin: '104px 24px 24px', display: 'flex', flexDirection: 'column', minHeight: `calc(90% - 80px)` }}>
                    <div className="site-layout-background" style={{ padding: 24, flexGrow: 1, borderRadius: 16 }}>
                        {children}
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center', height: 50, paddingTop: 14, background: 'transparent', color: '#94a3b8' }}>
                    COPYRIGHT © {moment().format("YYYY")} <a target={'_blank'} href="https://edifly-si.com/">Edifly Solusi Indonesia</a>, All rights Reserved
                </Footer>
            </Layout>
        </Layout>
    )
}
